<template>
  <!-- Card header -->
  <div role="tab" id="excecoes">
    <a href="#" @click.prevent.stop="toggle = !toggle">
      <p class="mb-0" style="color:black; font-size:13px;">
        <b>{{ item.excecao }}</b>
        <i class="fas fa-angle-right ml-1 transicao icone" :style="rotacao"></i>
      </p>
    </a>
    <!-- Card body -->
    <transition name="excecao-fade">
      <div v-if="toggle">
        <div class="card-body">
          <div v-if="item.ipi">
            <b>IPI:</b>
            {{ item.ipi }}
          </div>
          <div v-if="item.aliquotas">
            <b>ICMS:</b>
            <a href="#" class="ml-1" v-b-modal="item.excecao">Consultar</a>
            <!-- Modal -->
            <transition name="modaltransicao">
              <b-modal :id="item.excecao" title="Alíquotas do ICMS" size="lg">
                <div slot="default">
                  <div class="alert alert-warning" role="alert">
                    <span class="text-warning f-w">NOTA:</span> Para informações do Fundo de Combate a Pobreza
                    <a
                      class="ml-2"
                      target="_blank"
                      href="https://www.lefisc.com.br/boletins/2020/setembro_semana_4/fundo_amparo_pobreza/index.asp"
                    >clique aqui</a>
                  </div>
                  <table class="table w-100">
                    <div class="w-100">
                      <tr class="row">
                        <th class="col-md-6">Estado</th>
                        <th class="col-md-6">NCM</th>
                      </tr>
                    </div>
                    <div v-for="(aliquota, index) in item.aliquotas" :key="index" class="w-100">
                      <hr class="hr" />
                      <tr class="row">
                        <div class="col-md-12">
                          <div class="row">
                            <td class="col-6">{{ aliquota.estado }}</td>
                            <td class="col-6">{{ aliquota.icms }}%</td>
                            <table class="table" v-if="aliquota.notas">
                              <td colspan="2" style="font-size:10px" class="w-100">
                                <b>Nota Lefisc:</b>
                                {{ aliquota.notas }}
                              </td>
                            </table>
                          </div>
                        </div>
                        <hr class="hr" />
                      </tr>
                    </div>
                  </table>
                </div>
                <div slot="modal-footer" class="w-100">
                  <b-button
                    variant="info"
                    size="sm"
                    class="float-right"
                    @click="$bvModal.hide(item.excecao)"
                  >Fechar</b-button>
                </div>
              </b-modal>
            </transition>
          </div>
          <div v-if="item.piscofins">
            <b>PIS/COFINS:</b>
            <p style="font-size:12px" v-html="item.piscofins"></p>
          </div>
        </div>
      </div>
    </transition>
    <!-- Accordion card -->
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      toggle: false
    };
  },

  computed: {
    rotacao: function() {
      if (this.toggle) {
        return {
          transform: "rotateZ(90deg)",
          "background-color": "rgb(230, 230, 230)"
        };
      } else {
        return {
          transform: "rotateZ(0deg)",
          "background-color": "white"
        };
      }
    }
  }
};
</script>

<style scoped>
.excecao-fade-enter,
.excecao-fade-leave-to {
  min-height: 0;
  max-height: 0;
  opacity: 0;
}
.excecao-fade-enter-to,
.excecao-fade-leave {
  min-height: 1;
  max-height: 400px;
  opacity: 1;
}
.excecao-fade-enter-active,
.excecao-fade-leave-active {
  transition: all 0.5s;
}

.transicao {
  transition: all 0.5s;
}

.icone {
  border-radius: 100%;
  padding: 3px 7px;
  border: 1px solid rgb(199, 199, 199);
  height: 20px;
  width: 20px;
}

.hr {
  border-bottom: 1px solid #eceff8;
  border-top: 0 none;
  margin: 0px 0;
  padding: 0;
}
</style>